import React from "react";
import styled from "styled-components";

export default styled.div`
    font-size: 16px;
    color: #6A6D90;
    margin-top: 10px;
`;